import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ApiEndpointService {
  private apiBase = '';
  setApiBase(base: string) { this.apiBase = (base || '').trim().replace(/\/+$/, ''); }
  getApiBase() { return this.apiBase; }
  buildUrl(path: string) {
    const clean = path.startsWith('/') ? path : `/${path}`;
    return this.apiBase ? `${this.apiBase}${clean}` : clean;
  }
}
